import { useMemo } from "react";
import { Visitor } from "@/graphql/generated/schema";

export const useVisitorSelection = (
  visitors: Visitor[] | any,
  totalCount: number,
  selectedRows: Visitor[],
) => {
  const inVisitors = selectedRows.length
    ? selectedRows.filter((v) => v?.signedType === "In")
    : visitors.filter((v: Visitor) => v?.signedType === "In");

  const outVisitors = selectedRows.length
    ? selectedRows.filter((v) => v?.signedType === "Out" && !v.anonymize)
    : visitors.filter((v: Visitor) => v?.signedType === "Out" && !v.anonymize);
  const hasSelection = selectedRows.length > 0;
  const actionOptions = useMemo(
    () => [
      {
        id: "Export",
        label: `Export${!hasSelection ? " All" : ""} (${selectedRows.length || totalCount})`,
      },
      {
        id: "Out",
        label: `Sign Out${!hasSelection ? " All" : ""} (${inVisitors.length})`,
        disabled: inVisitors.length === 0,
      },
      {
        id: "Anonymize",
        label: `Anonymize${!hasSelection ? " All" : ""} (${outVisitors.length})`,
        disabled: outVisitors.length === 0,
      },
    ],
    [hasSelection, inVisitors.length, outVisitors.length, selectedRows.length, totalCount],
  );

  return {
    selectedRows,
    inVisitors,
    actionOptions,
  };
};
